import { render, staticRenderFns } from "./CTAType1.vue?vue&type=template&id=4efd7282&scoped=true"
import script from "./CTAType1.vue?vue&type=script&lang=js"
export * from "./CTAType1.vue?vue&type=script&lang=js"
import style0 from "./CTAType1.vue?vue&type=style&index=0&id=4efd7282&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efd7282",
  null
  
)

export default component.exports